import React from 'react';
import PropTypes from 'prop-types';

export default function Progress({
  active,
  progressPercentage,
  styleContainer,
}) {
  return (
    <div className="card-view-progress" style={styleContainer}>
      {active && <div className="card-view-progress-active" />}
      {active && progressPercentage > 0 && (
        <div
          className="card-view-progress-current"
          style={{ width: `${progressPercentage}%` }}
        />
      )}
    </div>
  );
}

Progress.defaultProps = {
  progressPercentage: 0,
  styleContainer: {
    height: '3px',
    marginTop: '3px',
  },
};
Progress.propTypes = {
  progressPercentage: PropTypes.number,
  styleContainer: PropTypes.shape({
    height: PropTypes.string,
    marginTop: PropTypes.string,
  }),
  active: PropTypes.bool,
};
